<template>
  <svg
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    preserveAspectRatio="none"
    style="z-index: 1"
  >
    <title>{{ hint }}</title>
    <defs>
      <linearGradient
        id="KeyGradientCross1"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="24"
        x2="0"
        y2="48"
      >
        <stop style="stop-opacity: 1; stop-color: #99A1AF" offset="0" />
        <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #99a1af " offset="1" />
      </linearGradient>
      <linearGradient
        id="KeyGradientCross2"
        gradientUnits="userSpaceOnUse"
        x1="24"
        y1="0"
        x2="48"
        y2="0"
      >
        <stop style="stop-opacity: 1; stop-color: #99A1AF" offset="0" />
        <stop style="stop-opacity: 1; stop-color: #e3e2e2" offset="0.50" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="1" />
      </linearGradient>
      <linearGradient
        id="OilGradientCross1"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="24"
        x2="0"
        y2="48"
      >
            
        <!--https://tailwindcss.com/docs/colors gray-->
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0" />
        <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="1" />
      </linearGradient>
      <linearGradient
        id="OilGradientCross2"
        gradientUnits="userSpaceOnUse"
        x1="24"
        y1="0"
        x2="48"
        y2="0"
      >
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="0" />
        <stop style="stop-opacity: 1; stop-color: #99a1af" offset="0.5" />
        <stop style="stop-opacity: 1; stop-color: #868485 " offset="1" />
      </linearGradient>
      <rect id="main_cross" y="24" width="72" height="24" />
      <path id="path_cross_0" d="M 24,0  v 24 Q 34 34 48 24 V 0 z" />
      <path id="path_cross_1" d="M 24,72 V 48 Q 36 36 48 48 V 72 z" />
    </defs>
    <g :visibility="fState[0]">
      <use href="#main_cross" fill="url(#KeyGradientCross1)" />
      <use href="#path_cross_0" fill="url(#KeyGradientCross2)" />
      <use href="#path_cross_1" fill="url(#KeyGradientCross2)" />
    </g>
    <g :visibility="fState[1]">
      <use href="#main_cross" fill="url(#OilGradientCross1)" />
      <use href="#path_cross_0" fill="url(#OilGradientCross2)" />
      <use href="#path_cross_1" fill="url(#OilGradientCross2)" />
    </g>
    <g :visibility="fState[4]">
      <use href="#main_cross" fill="url(#KeyGradientCross1)" />
      <use href="#path_cross_0" fill="url(#KeyGradientCross2)" />
      <use href="#path_cross_1" fill="url(#KeyGradientCross2)" />
    </g>
    <g :visibility="fState[3]">
      <use href="#main_cross" fill="url(#KeyGradientCross1)" />
      <use href="#path_cross_0" fill="url(#KeyGradientCross2)" />
      <use href="#path_cross_1" fill="url(#KeyGradientCross2)" />
    </g>
    <g :visibility="fState[10]">
      <use href="#main_cross" fill="url(#KeyGradientCross1)" />
      <use href="#path_cross_0" fill="url(#KeyGradientCross2)" />
      <use href="#path_cross_1" fill="url(#KeyGradientCross2)" />
    </g>
  </svg>
</template>

<script>
import MixinStates from "./mixin-states.js";

export default {
  name: "pipeline_cross",
  mixins: [MixinStates],
};
</script>
